/* global globalThis */
// Chiffrement de la liste des enfants attendus, dans le navigateur.
// Format identique à api/app/crypto.js (v3) et à l'app : [0x03][nonce 12][ct‖tag16],
// clé AES brute de 32 octets enveloppée en RSA-OAEP SHA-256.

const RSA_ENCRYPTION_ALG_ID = [0x30, 0x0d, 0x06, 0x09, 0x2a, 0x86, 0x48, 0x86, 0xf7, 0x0d, 0x01, 0x01, 0x01, 0x05, 0x00];

function derLength(n) {
    if (n < 0x80) return [n];
    const bytes = [];
    while (n > 0) { bytes.unshift(n & 0xff); n >>= 8; }
    return [0x80 | bytes.length, ...bytes];
}

function base64ToBytes(b64) {
    return Uint8Array.from(atob(b64), (c) => c.charCodeAt(0));
}

function bytesToBase64(bytes) {
    let s = '';
    for (let i = 0; i < bytes.length; i++) s += String.fromCharCode(bytes[i]);
    return btoa(s);
}

/** Les unités publient une clé PEM PKCS#1 ; Web Crypto n'importe que du SPKI. */
export function pemToSpkiDer(pem) {
    const isPkcs1 = pem.includes('BEGIN RSA PUBLIC KEY');
    const der = base64ToBytes(pem.replace(/-----(BEGIN|END) [A-Z ]+-----/g, '').replace(/\s+/g, ''));
    if (!isPkcs1) return der;
    const bitString = [0x03, ...derLength(der.length + 1), 0x00, ...der];
    const body = [...RSA_ENCRYPTION_ALG_ID, ...bitString];
    return new Uint8Array([0x30, ...derLength(body.length), ...body]);
}

export async function encryptExpectedList(payload, unitPublicKeyPem) {
    const { subtle } = globalThis.crypto;
    const aesRaw = globalThis.crypto.getRandomValues(new Uint8Array(32));
    const nonce = globalThis.crypto.getRandomValues(new Uint8Array(12));
    const aesKey = await subtle.importKey('raw', aesRaw, 'AES-GCM', false, ['encrypt']);
    const plaintext = new TextEncoder().encode(JSON.stringify(payload));
    const ct = new Uint8Array(await subtle.encrypt({ name: 'AES-GCM', iv: nonce }, aesKey, plaintext));
    const blob = new Uint8Array(1 + nonce.length + ct.length);
    blob[0] = 0x03;
    blob.set(nonce, 1);
    blob.set(ct, 1 + nonce.length);

    const rsaKey = await subtle.importKey(
        'spki', pemToSpkiDer(unitPublicKeyPem), { name: 'RSA-OAEP', hash: 'SHA-256' }, false, ['encrypt']
    );
    const wrapped = new Uint8Array(await subtle.encrypt({ name: 'RSA-OAEP' }, rsaKey, aesRaw));
    return { blob: bytesToBase64(blob), key: bytesToBase64(wrapped) };
}
